import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "terms-of-use-modal-component" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title-info" }, "Termos de Uso e Política de Privacidade", -1)
const _hoisted_3 = { class: "scroll-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Termos de uso")
], -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Política de Privacidade")
], -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, {
      class: "custom-modal",
      ref: "base-modal"
    }, {
      content: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: "terms",
            innerHTML: _ctx.termsHtml
          }, null, 8, _hoisted_5),
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", {
            class: "privacy",
            innerHTML: _ctx.privacyHtml
          }, null, 8, _hoisted_8)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            class: "btn btn-default btn-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.acceptTerms()))
          }, " Eu aceito, continuar ")
        ])
      ]),
      _: 1
    }, 512)
  ]))
}